// Widget Scripts
import cardWidgetTierTwo from './js/widgets/cardWidgetTierTwo.js';
import cardWidgetTierThree from './js/widgets/cardWidgetTierThree.js';
import cardWidgetEvents from './js/widgets/cardWidgetEvents.js';
import cardWidgetTierFour from './js/widgets/cardWidgetTierFour.js';
import swiperWidget from './js/widgets/swiperWidget.js';
import cssSponsors from './js/widgets/cssSponsors.js';
import cardWidgetVideo from './js/widgets/cardWidgetVideo.js';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(function() {
    cardWidgetTierTwo();
    cardWidgetTierThree();
    cardWidgetEvents();
    cardWidgetTierFour();
    swiperWidget();

    // Events Mode
     if ($('body').hasClass('eventsMode')) {
      cardWidgetVideo(); 
    } else {
      swiperWidget();
    }
  });
}

$(document).ready(function() {
  cssSponsors();
});